import type { ReactNode } from 'react';
import React from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../filterChip.module.scss';

/** Custom props */
type Props = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
};

export function Label(props: Props) {
  const { children, className } = props;

  const classNames = cx(styles[toCamelCase('filterChip', 'label')], className);

  return (
    <span className={classNames} data-testid="filterChip-label">
      {children}
    </span>
  );
}

export default Label;
